<template>
    <div class="h100 ml5 mr5">
        <IScroll @loadBottom="loadMore" ref="scroll" id="scrollWrap">
            <div class="myContentBox_92fanli pt5 pb5 mt10" v-for="(item,index) in list"
                 v-on:click='toDoyenDetail(item.id)' :key="index">
                <div class="ml7 mr7">
                    <div class="flexBox mt5 mb5">
                        <div class="flexBox-cell-30 myimg flexBoxMr5 communityInfoImg"
                             v-for="(img, imgIndex) in item.quality_images" :key="imgIndex">
                            <img v-bind:src="img" />
                        </div>
                    </div>
                    <p class="communityInfoTitle">{{item.title}}</p>
                    <p class="communityInfoTxt">{{item.updated_at_str}}</p>
                </div>
            </div>
        </IScroll>
        <div class="goTopBtn">
            <img v-if="topStatus" src="@/assets/images/backTop.png" v-on:click="toTop(0)">
        </div>
    </div>
</template>

<script>
    import IScroll from '../../components/IScroll';

    export default {
        components: {IScroll},
        props: {
            styleName: {
                type: String,
                default: 'main'
            },
            list: {
                type: Array
            },
            isTop: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                btnFlag: false
            }
        },
        computed: {
            topStatus() {
                return this.btnFlag && this.isTop;
            },
        },
        updated() {
            // document.getElementById('scrollWrap').addEventListener('scroll', this.scrollToTop)
            this.$refs.scroll.$el.addEventListener('scroll', this.scrollToTop);
        },
        methods: {
            loadMore: function () {
                this.$emit('loadMore', true);
            },
            scrollToTop: function () {
                this.btnFlag = document.getElementById('scrollWrap').scrollTop > 180;
                this.$emit('scrollToTop', document.getElementById('scrollWrap').scrollTop);
            },
            toDoyenDetail: function (id) {
                const route = {
                    name: 'doyen-detail',
                    query: {
                        id
                    }
                };
                this.$router.push(route);
            },
            toTop: function (top) {
                document.getElementById('scrollWrap').scrollTop = top;
            }
        }
    }
</script>

<style scoped>

</style>
